class SwiperJS {
    constructor(parent, data) {
        this.parent = parent
        this.init()
    }
    init() {
        document.querySelectorAll('[data-swiper]').forEach(el => {
            new SwiperJSItem(el)
        })
    }
}

class SwiperJSItem {
    constructor(el) {
        this.el = el
        this.init()
    }
    init() {
        this.swiper = new Swiper(this.el, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
        });
    }
}

export default SwiperJS